// Background/hero videos defer their source until the page has finished
// loading, so the MP4 never competes with page-critical resources. Markup
// contract: <video data-deferred ...><source data-src="..."></video> —
// autoplay is intentionally absent (it would override preload="none");
// playback starts here instead, and users who prefer reduced motion get
// the video paused until they press play.
//
// Each video is followed by a [data-video-toggle] play/pause button
// (WCAG 2.2.2: auto-playing motion needs a pause control).
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const toggleFor = video => {
    const next = video.nextElementSibling;
    return next && next.matches('[data-video-toggle]') ? next : null;
};

const syncToggle = (toggle, playing) => {
    if (!toggle) return;
    toggle.dataset.state = playing ? 'playing' : 'paused';
    toggle.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
};

const loadDeferredVideos = () => {
    for (const video of document.querySelectorAll('video[data-deferred]')) {
        for (const source of video.querySelectorAll('source[data-src]')) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
        }
        video.removeAttribute('data-deferred');
        video.load();

        const toggle = toggleFor(video);
        video.addEventListener('play', () => syncToggle(toggle, true));
        video.addEventListener('pause', () => syncToggle(toggle, false));
        toggle?.addEventListener('click', () => {
            if (video.paused) {
                video.play().catch(() => {});
            } else {
                video.pause();
            }
        });

        if (prefersReducedMotion) {
            syncToggle(toggle, false);
        } else {
            const playing = video.play();
            if (playing) playing.catch(() => syncToggle(toggle, false));
        }
    }
};

if (document.readyState === 'complete') {
    loadDeferredVideos();
} else {
    window.addEventListener('load', () => {
        (window.requestIdleCallback || window.setTimeout)(loadDeferredVideos);
    });
}
